module.exports = __webpack_public_path__ + "static/media/etat-sante-red.62c2cf31.svg";